// /sign-in — public (no `_authed` guard: a signed-out visitor must be able
// to reach this or there's a redirect loop — see routes/guards.tsx's
// `_authed.beforeLoad`, which sends unauthenticated hits on any guarded page
// here with `?redirect_url=`). Real route, replacing the placeholder.
//
// A single splat route (`/sign-in/$`) covers BOTH `/sign-in` itself and
// Clerk's own path-routed sub-steps (SSO callback, `factor-one`,
// `factor-two`, etc. — anything `<SignIn routing="path" path="/sign-in" />`
// pushes under its own path), mirroring Next's `[[...sign-in]]` optional
// catch-all convention the Clerk docs assume. A bare path segment of `$` is
// TanStack Router's wildcard token (see @tanstack/router-core's
// parseSegment — `part === '$'` -> greedy match of everything from that
// point on, INCLUDING a zero-length match, so `/sign-in` alone still
// resolves through this one route). A separate exact `/sign-in` sibling
// route was tried first and dropped: with both present, TanStack Router's
// dev-only round-trip check (@tanstack/router-core's router.js:291) warns
// "Generated path .../ matched route .../$ instead" on every navigation —
// the wildcard sibling wins the ambiguous match anyway, so the exact route
// was dead weight, not a fallback.
import { lazy } from 'react';
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './__root';

const SignInPage = lazy(() => import('@/app/sign-in/page'));

export const signInSplatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sign-in/$',
  component: SignInPage,
});

// /signin (no dash) — legacy alias. Ported from the old app's
// app/signin/page.tsx: redirect straight to /sign-in, preserving every
// query param (redirect_url included) verbatim.
export const signinAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/signin',
  beforeLoad: ({ location }) => {
    throw redirect({ href: `/sign-in${location.searchStr}` });
  },
});
